export default __webpack_public_path__ + "static/media/job_offer13_s.59d69866.jpg";